import { Grid, Link, Typography } from '@mui/material';
import Info from '@mui/icons-material/Info';
import React from 'react';
import styles from './style';

interface IProps {
  messageUrl: string;
  url?: string;
  children?: React.ReactNode;
}

const MessageInfo: React.FC<IProps> = ({ messageUrl, url, children }) => (
  <Grid container className="info" sx={styles}>
    <Info fontSize="small" className="icon" />
    <Typography variant="body2">{children}</Typography>
    {url ? (
      <Link
        className="defaultLink"
        color="secondary"
        variant="body2"
        href={url}
        style={{ marginTop: '11px' }}
      >
        {messageUrl}
      </Link>
    ) : (
      <Typography dangerouslySetInnerHTML={{ __html: messageUrl }} />
    )}
  </Grid>
);

export default MessageInfo;
